import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { drawerContainer } from "./drawer.module.scss";

const Container = ({ className, ...props }) => (
  <div className={classNames(drawerContainer, className)} {...props}/>
);

Container.propTypes = {
  className: PropTypes.string
};

Container.defaultProps = {
  className: ""
};

export default Container;
